 
const isDev = import.meta.env?.MODE === 'development';
const isDebugFlagEnabled = typeof window !== 'undefined' && window.__DEBUG__ === true;

const shouldLog = isDev || isDebugFlagEnabled
const noop = () => {
};


type LogStyleOptions = {
    label?: string;
    style?: string;
    args?: unknown[];
};

function getCallerLine(): string {
    const err = new Error();
    const stack = err.stack?.split('\n') ?? [];
    // The caller is typically at index 3 or 4
    const caller = stack.find((line) =>
        line.includes('at') &&
        !line.includes('consoleHelper') &&
        !line.includes('Error')
    );
    return caller?.trim() ?? '';
}

function styledLog({label = '', style = '', args = []}: LogStyleOptions): void {
    if (!shouldLog) return;
    const caller = getCallerLine();
    console.log(
        `%c${label}\n%c@ ${caller}`,
        style,
        'color: gray; font-style: italic;',
        ...args
    );
}

// Default short-hands for common styles
const makeStyled = (label: string, style: string) => (...args: unknown[]) =>
    styledLog({label, style, args});

const devConsole = shouldLog
    ? {
        log: console.log.bind(console),
        warn: console.warn.bind(console),
        error: console.error.bind(console),
        debug: console.log.bind(console),
        table: console.table.bind(console),
        dir: console.dir.bind(console),
        info: console.info.bind(console),

        label: styledLog,

        // Optional presets
        success: makeStyled('✔ SUCCESS', 'background: green; color: white; padding: 2px 6px; border-radius: 2px;'),
        fail: makeStyled('✖ ERROR', 'background: crimson; color: white; padding: 2px 6px; border-radius: 2px;'),
        badge: makeStyled('ℹ INFO', 'background: #444; color: #eee; padding: 2px 6px; border-radius: 2px;'),
    }
    : {
        log: noop,
        warn: noop,
        error: noop,
        debug: noop,
        table: noop,
        dir: noop,
        info: noop,
        label: noop,
        success: noop,
        fail: noop,
        badge: noop,
    };

export const d = devConsole;
